module.exports = __webpack_public_path__ + "static/media/ic_input_65.8b7d4548.svg";